import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'hsc-oidc-callback-page',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="flex h-[calc(100vh-453px)] items-center justify-center">
      <bolt-waiting-indicator>Logging in...</bolt-waiting-indicator>
    </div>
  `,
})
export class OIDCCallbackPage {}
